<template>
  <div>
    <div class="modelMain">
      <div class="modeltemplate">
        <div class="close" @click="closeModal()">&times;</div>
        <div class="header">
          <div class="tagtitle">
            <div class="callbg"></div>
            <div class="custom_tag" @click="selecttitle($event)">
              <span @click="showAllModel" class="iconfont">&#xe692; 全部模型</span>
              <span @click="showFavorite" class="iconfont">&#xe669; 我的收藏</span>
            </div>
          </div>
          <div class="modelsearch">
            <input type="text" v-model="search" placeholder="输入模型名称、标签搜索" maxlength="100">
            <span @click="searchFilter(search)">搜索</span>
          </div>
        </div>
        <div class="tagtype">
          <div class="alltype" @click="selecttype($event)">
            <span class="active_type">全部模型</span>
            <span>海报模特</span>
            <span>手图生成</span>
            <span>海报生成</span>
            <span>美甲生成</span>
            <span>料体生成</span>
          </div>
          <select class="optiontype" v-model="selectedType" @change="filterModel" name="" id="">
            <option value="基础模型F.1">基础模型F.1</option>
            <option value="基础模型F.1-p">基础模型F.p</option>
            <option value="基础模型SDXL">基础模型SDXL</option>
            <option value="基础模型SD1.5">基础模型SD1.5</option>
          </select>
        </div>
        <div class="model_list">
          <div class="nonetips" v-if="modelTempelate.length === 0 || null" v-loading="loading">当前模型库为空!</div>
          <div class="model_items" v-else v-loading="loading">
            <div class="model_item" v-show="item.visible" v-for="item in modelTempelate" :key="item.id">
              <div class="function">
                <span @click="saveFavorite(item)" v-show="isStatus === 'modelList'" class="iconfont">&#xe669;</span>
                <span @click="showDeleteDialog(item)" v-show="isStatus === 'favoriteList'"
                  class="iconfont">&#xe637;</span>
                <span @click="useModel(item)">使用模型</span>
                <span></span>
              </div>
              <img :src="item.modelCover" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" height="20%" class="custom-dialog" :modal="false"
      :destroy-on-close=true>
      <span class="text">{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancle" @click="dialogVisible = false">取 消</el-button>
        <el-button class="ok" type="primary" @click="dialog(tempId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notification } from '@/utils/notification'
export default {
  name: 'modelTemplate',
  props: {
    modelTempvisible: {
      type: Boolean,
      default: false
    },
    favoriteParams: {
      type: String,
      default: ''
    }
  },
  watch: {
    modelTempvisible: function (val) {
      const modelMain = document.querySelector('.modelMain')
      if (val) {
        modelMain.style.top = '0%'
        modelMain.style.transform = 'scale(1)'
        modelMain.style.opacity = '1'
      } else {
        modelMain.style.top = '100%'
        modelMain.style.transform = 'scale(0.5)'
        modelMain.style.opacity = '0'
      }
    }
  },
  data() {
    return {
      modelTempelate: [],
      dialogVisible: false,
      msg: '',
      tempId: null,
      visibleNodes: new Set(), // 用于存储当前应该显示的节点ID
      observer: null, // 用于存储 IntersectionObserver 实例
      selectedType: '基础模型F.1',
      search: '',
      loading: true,
      isStatus: 'modelList'
    }
  },
  async created() {
    await this.$store.dispatch('model_list/getUserInfo')
    await this.$store.dispatch('model_list/getModelList')
    this.modelTempelate = this.$store.getters['model_list/sourceModelList']
    if (this.modelTempelate.length >= 0) {
      this.loading = false
    }
    // 延迟执行确保DOM完全渲染
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver()
      }, 100)
    })
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc)
    window.addEventListener('keydown', this.handleEnter)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
    window.removeEventListener('keydown', this.handleEnter)
    this.destroyIntersectionObserver()
  },
  methods: {
    // 查看全部模型
    async showAllModel() {
      this.loading = true
      this.isStatus = 'modelList'
      this.modelTempelate = []
      this.modelTempelate = this.$store.getters['model_list/sourceModelList']
      if (this.modelTempelate.length > 0) {
        this.loading = false
      }
      // 延迟执行确保DOM完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.initIntersectionObserver()
        }, 100)
      })
    },
    // 保存收藏
    async saveFavorite(data) {
      await this.$store.dispatch('model_list/saveMyFavorite', data)
      if (this.$store.state.model_list.back !== '写入数据成功') {
        this.open1('warning', 'red', '您已经收藏过当前模型!')
      } else {
        this.open1('success', 'green', '当前模型收藏成功!')
      }
    },
    // 查看收藏列表
    async showFavorite() {
      this.loading = true
      this.isStatus = 'favoriteList'
      this.modelTempelate = []
      await this.$store.dispatch('model_list/getFavoriteList')
      const res = this.$store.getters['model_list/sourceFavoriteList']
      if (res && res.length >= 0) {
        this.loading = false
      }
      this.modelTempelate = res
      // 延迟执行确保DOM完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.initIntersectionObserver()
        }, 100)
      })
    },
    handleEnter(event) {
      if (event.key === 'Enter') {
        this.searchFilter(this.search)
      }
    },
    // 搜索过滤
    searchFilter(search) {
      if (this.search.split(' ') === '') {
        return
      }
      this.modelTempelate.forEach(item => {
        if (item.modelName.includes(search)) {
          item.visible = true
        } else {
          item.visible = false
        }
      })
    },
    // 过滤模型
    filterModel() {
      this.modelTempelate.forEach(item => {
        if (item.modelType.includes(this.selectedType)) {
          item.visible = true
        } else {
          item.visible = false
        }
      })
    },
    // 使用模型
    useModel(data) {
      this.$emit('selectCheck', data)
      this.open1('success', 'green', '成功应用模型到当前生成状态中!')
    },
    // 关闭模态框
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeModal()
      }
    },
    // 标头标签
    selecttitle(event) {
      const bg = document.querySelector('.callbg')
      const customTag = document.querySelector('.custom_tag')
      const clickedElement = event.target

      // 计算相对位置的百分比
      const containerWidth = customTag.offsetWidth
      const elementLeft = clickedElement.getBoundingClientRect().left
      const containerLeft = customTag.getBoundingClientRect().left
      const relativeLeft = elementLeft - containerLeft

      // 转换为百分比
      const percentageLeft = (relativeLeft / containerWidth) * 100
      bg.style.left = `${percentageLeft}%`
    },
    // 选定标签状态
    selecttype(event) {
      const type = document.querySelectorAll('.alltype span')
      if (event.target.tagName === 'SPAN') {
        type.forEach(item => {
          item.classList.remove('active_type')
        })
        event.target.classList.add('active_type')

        const selectedTag = event.target.innerText

        // 建立标签与modelName关键词的映射关系
        const tagMap = {
          全部模型: '', // 空字符串表示不筛选
          海报模特: '模特',
          手图生成: '手图',
          海报生成: '海报',
          美甲生成: '美甲',
          料体生成: '料体'
        }

        const keyword = tagMap[selectedTag] || selectedTag

        if (selectedTag === '全部模型') {
          this.modelTempelate.forEach(item => {
            item.visible = true
          })
        } else {
          // 根据关键词筛选
          this.modelTempelate.forEach(item => {
            item.visible = item.modelName.includes(keyword)
          })
        }
      }
    },
    // 消息通知栏
    open1(type = 'warning', color, notion) {
      notification(type)
      const h = this.$createElement
      this.$notify({
        title: '系统通知',
        type: type,
        message: h('i', { style: `color: ${color}` }, notion)
      })
    },
    // 关闭模态框
    closeModal() {
      this.$emit('update:modelTempvisible', false)
    },
    showDeleteDialog(item) {
      this.dialogVisible = true
      this.msg = '你确定删除当前模型收藏么？'
      this.tempId = item.id
      notification('warning') // 这样就能确保在点击时执行
    },
    // 弹窗对话框
    async dialog(tempId) {
      this.dialogVisible = false
      notification('success')
      await this.$store.dispatch('model_list/deleteMyFavorite', tempId)
      this.loading = true
      this.modelTempelate = []
      await this.$store.dispatch('model_list/getFavoriteList')
      this.modelTempelate = this.$store.getters['model_list/sourceFavoriteList']
      if (this.modelTempelate.length >= 0) {
        this.loading = false
      }
      // 延迟执行确保DOM完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.initIntersectionObserver()
        }, 100)
      })
    },
    // 页面效果
    initIntersectionObserver() {
      this.$nextTick(() => {
        const nodes = document.querySelectorAll('.model_item')
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const nodeId = parseInt(entry.target.dataset.id)
              if (entry.isIntersecting) {
                this.visibleNodes.add(nodeId)
                entry.target.classList.add('fade-in')
              } else {
                this.visibleNodes.delete(nodeId)
                entry.target.classList.remove('fade-in')
              }
            })
          }, {
            root: document.querySelector('.modelMain'),
            rootMargin: '50px', // 提前50px触发
            threshold: 0.1
          })

          nodes.forEach(node => {
            this.observer.observe(node)
            // 立即检查元素是否已在视口中
            const rect = node.getBoundingClientRect()
            const rootRect = document.querySelector('.modelMain').getBoundingClientRect()
            if (
              rect.top < rootRect.bottom &&
              rect.bottom > rootRect.top
            ) {
              // 元素已经在视口中
              node.classList.add('fade-in')
              this.visibleNodes.add(parseInt(node.dataset.id))
            }
          })
        } else {
          // 如果浏览器不支持 IntersectionObserver，则默认全部显示
          this.parent_node.forEach(item => {
            this.visibleNodes.add(item.id)
          })
        }
      })
    },
    destroyIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

// 状态属性值
.active_type {
  background: @basicselect;
  border-radius: @border_radius_3;
}

// 弹窗
.custom-dialog {
  .custom-dialog .el-dialog__header {
    background-color: #eef1f6;
    border-bottom: 1px solid #dcdfe6;
    text-align: center;
  }

  .custom-dialog .el-dialog__footer {
    text-align: center;
  }

  .dialog-footer .el-button {
    margin: 0 5px;
    border: 1px solid @basicselect;
    color: @font_gray;
    border-radius: 10px;
    transition: all 0.5s;

    &:hover {
      transition: all 0.5s;
      background-color: @morejoy;
      color: @font_white;
    }
  }

  .ok,
  .cancle {
    background-color: white;
    display: inline-block;
    padding: 12px 15px;
    font-size: 22px;
  }

  span {
    font-size: 22px;
    color: @font_gray;
  }

}

.modelMain {
  position: fixed;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(2px);
  display: flex;
  z-index: 99;
  transform: scale(0.5);
  opacity: 0;
  transition: all 0.5s;
  overflow: hidden;

  .modeltemplate {
    position: absolute;
    padding: 15px;
    width: 1536px;
    height: 1152px;
    left: calc(50% + 180px);
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: @font_white;
    border-radius: @border_radius;
    box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.5s;

    .close {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 28px;
      color: @font_gray;
      cursor: pointer;
      transition: all 0.5s;
    }

    .header {
      width: 100%;
      height: 70px;
      display: flex;
      padding: 0px 50px 0px 0px;
      justify-content: space-between;
      // background: red;
      border-radius: @border_radius;
      transition: all 0.5s;

      .tagtitle {
        position: relative;
        width: 350px;
        height: 70px;
        display: flex;
        background-color: @basicselect;
        border-radius: @border_radius;
        align-items: center;
        transition: all 0.5s;

        .callbg {
          position: absolute;
          width: 167px;
          height: 60px;
          left: 5px;
          flex: 50%;
          background-color: @font_white;
          border-radius: @border_radius;
          transition: all 0.5s;
          z-index: 0;
        }

        .custom_tag {
          flex: 50%;
          padding: 5px;
          gap: 5px;
          display: flex;
          text-align: center;
          align-items: center;
          font-size: 25px;
          height: 60px;
          line-height: 60px;
          cursor: pointer;
          transition: all 0.5s;
          z-index: 1;

          span {
            flex: 50%;
            display: block;
            transition: all 0.5s;

            &:hover {
              font-size: 27px;
              transition: all 0.5s;
            }
          }
        }
      }

      .modelsearch {
        position: relative;
        width: 550px;
        height: 65px;
        background: @basicselect;
        border-radius: @border_radius_2;

        input {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background-color: transparent;
          border-radius: @border_radius;
          padding: 15px;
          font-size: 23px;
        }

        span {
          position: absolute;
          right: 15px;
          top: 15px;
          font-size: 20px;
          color: @font_gray;
          cursor: pointer;
        }
      }
    }

    .tagtype {
      width: 100%;
      height: 70px;
      padding: 5px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // background: red;
      margin-top: 10px;
      transition: all 0.5s;

      .alltype {
        display: flex;
        gap: 10px;
        align-items: center;
        transition: all 0.5s;
        cursor: pointer;

        span {
          height: 50px;
          padding: 10px 20px;
          display: block;
          font-size: 22px;
          line-height: 30px;
          border-radius: @border_radius_3;
          transition: all 0.5s;

          &:hover {
            font-size: 23px;
            opacity: 0.5;
            background: @basicselect;
            border-radius: @border_radius_3;
          }
        }
      }

      .optiontype {
        width: 170px;
        height: 50px;
        border: 1px solid @font_gray;
        text-align: center;
        border-radius: @border_radius_2;
        transition: all 0.5s;
        font-size: 18px;
        transition: all 0.5s;
        cursor: pointer;
      }
    }

    .model_list {
      width: 100%;
      height: calc(100% - 150px);
      border-radius: @border_radius_2;
      overflow-y: scroll;

      .nonetips {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        color: @font_gray;
      }

      .model_items {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
        height: 100%;
        border-radius: @border_radius_2;
        align-content: flex-start;

        .model_item {
          position: relative;
          display: flex;
          width: 293px;
          height: 430px;
          border-radius: @border_radius;
          overflow: hidden;
          cursor: pointer;
          opacity: 0;
          transform: translateY(20px) scale(0.8);
          transition: opacity 0.5s ease, transform 0.5s ease;

          &.fade-in {
            opacity: 1;
            transform: translateY(0) scale(1);
          }

          .function {
            opacity: 0;
            position: absolute;
            width: 293px;
            height: 430px;
            padding: 10px;
            display: flex;
            align-items: end;
            font-size: 18px;
            z-index: 3;
            color: @font_white;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0));
            transition: all 0.5s;

            span:nth-child(1),
            span:nth-child(2) {
              display: block;
              padding: 0px 5px;
              width: 80px;
              height: 40px;
              font-size: 18px;
              line-height: 40px;
              transition: all 0.5s;
              font-weight: 700;

              &:hover {
                font-size: 20px;
                transition: all 0.5s;
              }

            }

            span:nth-child(3) {
              display: block;
              width: 120px;
              padding: 5px 10px;
              height: 42px;
              text-align: center;
              line-height: 30px;
              font-size: 18px;
              border-radius: @border_radius_2;
              background: rgba(252, 119, 22, 0.9);
              backdrop-filter: blur(5px);
              transition: all 0.5s;

              &:hover {
                font-size: 20px;
                transition: all 0.5s;
              }
            }
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.5s;
          }

          &:hover {
            .function {
              opacity: 1;
              transition: all 0.5s;
            }

            img {
              transform: scale(1.1);
              transition: all 0.5s;
            }
          }
        }
      }

    }
  }
}
</style>
